/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_dense_vector.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts a multi-valued input of numbers, or a hexadecimal string, to a dense_vector.',
  examples: [
    'row ints = [1, 2, 3]\n| eval vector = to_dense_vector(ints)\n| keep vector',
  ],
  params: {
    field: 'multi-valued input of numbers or hexadecimal string to convert.',
  },
};

export default docs;
